export default "__VITE_ASSET__DkmveJm7__"